"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("./browser");
const helpers_1 = require("./helpers");
const Tracker_1 = require("./Tracker");
class Api {
    constructor() {
        this.tla = 'sea';
        this.tracker = null;
        this.L = 0;
        this.ya = 0;
        this.loaded = false;
    }
    processQueue(queue) {
        if (queue) {
            for (const args of queue) {
                if (args.length > 1) {
                    const method = [].shift.call(args);
                    if (method === 'send') {
                        this.tracker.send(...args);
                    }
                    else if (method === 'create') {
                        this.tracker = new Tracker_1.default(this, ...args);
                    }
                    else if (method === 'set') {
                        this.tracker.set(...args);
                    }
                }
            }
        }
    }
    initialize() {
        const pre = browser_1.default.getWindow()[this.tla];
        if (!pre || !pre.loaded) {
            this.L = pre && pre.l;
            this.ya = new Date().getTime();
            this.loaded = true;
            helpers_1.default.trace(`sea loaded: ${this.loaded}`);
            // takeover entrypoint
            browser_1.default.getWindow()[this.tla] = this.enqueue.bind(this);
            const queue = pre && pre.q;
            Array.isArray(queue) ? this.processQueue(queue) : helpers_1.default.trace(50);
        }
    }
    enqueue(...args) {
        this.processQueue([args]);
    }
}
exports.Api = Api;
exports.default = new Api();
